// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"b34bebb59ff71b6ca518","873":"b4b28ccb5dd07a23a023"}[chunkId] + ".js";
};